/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Performs smooth scroll to target position.
 * 
 * @param {HTMLElement | Document} scrollableContainer - Container to scroll
 * @param {number} targetScrollTop - Target scroll position
 * @returns {void}
 */
export function performSmoothScroll(
  scrollableContainer: HTMLElement | Document,
  targetScrollTop: number
): void {
  const isDocument = scrollableContainer === document.documentElement;
  
  if (isDocument) {
    window.scrollTo({
      top: targetScrollTop,
      behavior: 'smooth',
    });
    return;
  }
  
  (scrollableContainer as HTMLElement).scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  });
}

export { highlightField } from './scroll-to-field-highlight';
